import Section from '@components/Section';
import TagsCloud from '@components/TagsCloud';
import Text from '@components/Text';
import Title from '@components/Title';
import Underline from '@components/Underline';
import React from 'react';
import { StyledAboutContent, StyledAboutGroup } from './styled';

interface IAboutProps {
  children?: React.ReactNode;
}

const About:React.FC<IAboutProps> = (props) => {
  return (
    <Section id='Skills & Tools' scrollerId='Recent Works'>
      <StyledAboutGroup>
        <StyledAboutContent>
          <Title size={32}>
            <Underline>Skills</Underline> & Tools
          </Title>
          <Text>
            I have been working in front-end development <Underline>since 2017</Underline>, and have experience in solo development as well as experience in startups.
          </Text>
          <Text>
            I develop both simple and complex SPA-apps using <Underline>React</Underline>. Additionally, I work with SEO-friendly projects using <Underline>Next.js</Underline>.
          </Text>
          <Text>
            Talking about <Underline>my main stack</Underline>, it&apos;s React, Next.js, TypeScript, Styled Components, RTK (Redux Toolkit)/Zustand, Apollo Client/SWR/React Query.
          </Text>
        </StyledAboutContent>
        <TagsCloud />
      </StyledAboutGroup>
    </Section>
  );
}

export default About;
